import { useState } from 'react'
import { useMediaQuery } from '@mui/material'

import { AddEditFeed } from './components/modals/AddEditFeed'
import { budgetPreviews } from './components/BudgetPreviews'
import { Button } from '@components/shared/Button'
import { CardWrapper } from '@components/shared/CardWrapper'
import { detailedSummaryMock } from './helpers/mocks/detailedSummaryMock'
import { emotionTheme } from '@styles/theme'
import { Input } from '@components/shared/Input'
import { PageWrapper } from '@components/shared/PageWrapper'
import { parseDetailedSummaryGrid } from './helpers/parseDetailedSummaryGrid'
import { PreviewWrapper } from '@components/shared/PreviewWrapper'
import { ReturnModal } from '@components/modals/ReturnModal'
import { RowBox } from '@components/shared/RowBox'
import { Slider } from '@components/shared/Slider'
import { Table } from '@components/shared/Table'
import { Title } from '@components/shared/Title'
import { TrashSimple } from '@assets/svgs/TrashSimple'
import { useUser } from '@hooks/useUser'
import { DownloadIcon } from '@assets/svgs/DownloadIcon'
import { Select } from '@components/shared/Select'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { RowTableTotal } from '@components/shared/RowTableTotal'
import { parseFeedGrid } from './helpers/parseFeedGrid'
import { feedMock } from './helpers/mocks/feedMock'
import { parseNotFeedGrid } from './helpers/parseNotFeedGrid'
import { notFeedMock } from './helpers/mocks/notFeedMock'
import { AddEditNotFeed } from './components/modals/AddEditNotFeed'
import { useInventory } from './context'

import * as S from './styles'

export const Inventory = () => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  const { filiData } = useUser()
  const { exportPdf } = useInventory()

  const [openAddEditFeedModal, setOpenAddEditFeedModal] = useState(false)
  const [editFeedData, setEditFeedData] = useState<any>(null)
  const [openAddEditNotFeedModal, setOpenAddEditNotFeedModal] = useState(false)
  const [editNotFeedData, setEditNotFeedData] = useState<any>(null)
  const [openDeleteFeedModal, setOpenDeleteFeedModal] = useState(false)

  const handleOpenAddEditFeed = (data: any) => {
    setOpenAddEditFeedModal(true)
    setEditFeedData(data)
  }

  const handleOpenAddEditNotFeed = (data: any) => {
    setOpenAddEditNotFeedModal(true)
    setEditNotFeedData(data)
  }

  const handleOpenDeleteFeed = () => {
    setOpenDeleteFeedModal(true)
  }

  return (
    <>
      <PageWrapper
        breadcrumbData={[{ label: `Inventário Físico de Estoque (IFE) - ${filiData?.filiCode} ${filiData?.filiName}` }]}
      >
        <S.budgetPreviews>
          {isMobile ? (
            <Slider items={budgetPreviews()} />
          ) : (
            <PreviewWrapper>{budgetPreviews().map((item) => item)}</PreviewWrapper>
          )}
        </S.budgetPreviews>

        <Title
          label=""
          action={
            <Button colorType="outlineBlue" onClick={() => []}>
              Histórico por Período
            </Button>
          }
        />

        <CardWrapper>
          <RowBox columns={3}>
            <Input
              hasController={false}
              name="unitCode"
              label="Código da Unidade"
              value="UN - 001"
              isIcon={false}
              disabled
            />
            <Input
              hasController={false}
              name="unitDescription"
              label="Descrição da Unidade"
              value="Depósito Central - São Paulo"
              isIcon={false}
              disabled
            />
            <Input
              hasController={false}
              name="responsibleCount"
              label="Responsável pela Contagem"
              value="Jean Brian"
              isIcon={false}
              disabled
            />
            <Input
              hasController={false}
              name="updateDate"
              label="Data da Atualização"
              value="21/10/2024 - 14:30:22"
              isIcon={false}
              disabled
            />
            <Input
              hasController={false}
              name="previousMonthValue"
              label="Valor do Mês Anterior"
              value="R$ 1.245.890,50"
              isIcon={false}
              disabled
            />
            <Input
              hasController={false}
              name="currentMonthValue"
              label="Valor do Mês Atual"
              value="R$ 287.000,00"
              isIcon={false}
              disabled
            />
          </RowBox>
        </CardWrapper>

        <Title
          label="Resumo detalhado"
          action={
            <Button colorType="outlineBlue" onClick={exportPdf} rightIcon={<DownloadIcon />}>
              Exportar PDF
            </Button>
          }
        />

        <Table
          data={parseDetailedSummaryGrid({
            data: detailedSummaryMock
          })}
          fixedRow={{
            element: <RowTableTotal data={[{ label: 'Valor total', value: 150589.25 }]} />
          }}
          footer={{
            pagination: {
              currentPage: 1,
              itemsPerPage: 10,
              totalItems: 30,
              totalPages: 10,
              onPageChange: () => {}
            }
          }}
        />

        <Title label="Contagem por Produto" style={{ marginTop: 16 }} />

        <RowBox columns={2}>
          <RowBox columns={2}>
            <Select
              hasController={false}
              name="category"
              label="Categoria"
              value="all"
              options={[{ label: 'Todos', value: 'all' }]}
            />
            <Select
              hasController={false}
              name="description"
              label="Descrição"
              value="all"
              options={[{ label: 'Todos', value: 'all' }]}
            />
          </RowBox>

          <RowBox columns={3} style={{ marginBottom: 24 }}>
            <Select
              hasController={false}
              name="unit"
              label="Unidade"
              value={60}
              options={[{ label: '60', value: 60 }]}
            />
            <Select
              hasController={false}
              name="quantity"
              label="Quantidade"
              value={500}
              options={[{ label: '500', value: 500 }]}
            />

            <S.FilterButtons>
              <Button width="100%" colorType="outlineBlue" onClick={() => []} rightIcon={<FilterIcon />}>
                Filtrar
              </Button>

              <Button width="100%" colorType="outlineBlue" onClick={() => []} rightIcon={<CloseIcon />}>
                Limpar
              </Button>
            </S.FilterButtons>
          </RowBox>
        </RowBox>

        <Table
          headerTitle="Alimentar"
          data={parseFeedGrid({
            data: feedMock,
            onEdit: handleOpenAddEditFeed,
            onDelete: handleOpenDeleteFeed
          })}
          fixedRow={{
            element: <RowTableTotal data={[{ label: 'Valor total', value: 143500 }]} />
          }}
          footer={{
            actionButton: {
              onClick: () => handleOpenAddEditFeed(null),
              labelButton: 'Adicionar Alimentar'
            },
            pagination: {
              currentPage: 1,
              itemsPerPage: 10,
              totalItems: 30,
              totalPages: 10,
              onPageChange: () => {}
            }
          }}
        />

        <RowBox columns={2} style={{ marginTop: 64 }}>
          <RowBox columns={2}>
            <Select
              hasController={false}
              name="category"
              label="Categoria"
              value="all"
              options={[{ label: 'Todos', value: 'all' }]}
            />
            <Select
              hasController={false}
              name="description"
              label="Descrição"
              value="all"
              options={[{ label: 'Todos', value: 'all' }]}
            />
          </RowBox>

          <RowBox columns={3} style={{ marginBottom: 24 }}>
            <Select
              hasController={false}
              name="unit"
              label="Unidade"
              value={60}
              options={[{ label: '60', value: 60 }]}
            />
            <Select
              hasController={false}
              name="quantity"
              label="Quantidade"
              value={500}
              options={[{ label: '500', value: 500 }]}
            />

            <S.FilterButtons>
              <Button width="100%" colorType="outlineBlue" onClick={() => []} rightIcon={<FilterIcon />}>
                Filtrar
              </Button>

              <Button width="100%" colorType="outlineBlue" onClick={() => []} rightIcon={<CloseIcon />}>
                Limpar
              </Button>
            </S.FilterButtons>
          </RowBox>
        </RowBox>

        <Table
          headerTitle="Não Alimentar"
          data={parseNotFeedGrid({
            data: notFeedMock,
            onEdit: handleOpenAddEditNotFeed,
            onDelete: handleOpenDeleteFeed
          })}
          fixedRow={{
            element: <RowTableTotal data={[{ label: 'Valor total', value: 143500 }]} />
          }}
          footer={{
            actionButton: {
              onClick: () => handleOpenAddEditNotFeed(null),
              labelButton: 'Adicionar Não Alimentar'
            },
            pagination: {
              currentPage: 1,
              itemsPerPage: 10,
              totalItems: 30,
              totalPages: 10,
              onPageChange: () => {}
            }
          }}
        />

        <S.Buttons>
          <Button width={isMobile ? '100%' : 165} colorType="outlineBlue" onClick={() => []}>
            Cancelar
          </Button>

          <Button width={isMobile ? '100%' : 190} colorType="solidBlue" onClick={() => []}>
            Finalizar Inventário
          </Button>

          <Button width={isMobile ? '100%' : 165} colorType="solidBlue" onClick={() => []}>
            Salvar
          </Button>
        </S.Buttons>
      </PageWrapper>

      <AddEditFeed data={editFeedData} open={openAddEditFeedModal} onClose={() => setOpenAddEditFeedModal(false)} />

      <AddEditNotFeed
        data={editNotFeedData}
        open={openAddEditNotFeedModal}
        onClose={() => setOpenAddEditNotFeedModal(false)}
      />

      <ReturnModal
        open={openDeleteFeedModal}
        headerIcon={<TrashSimple />}
        headerTitle="Você tem certeza?"
        title="Deseja realmente excluir este produto?"
        cancelButtonText="Cancelar"
        confirmButtonText="Confirmar"
        onClose={setOpenDeleteFeedModal}
        onConfirm={() => []}
      />
    </>
  )
}
